import request from "@/network/request"
const origin = 'https://wx.sxmfyy.com/home';
export function requestWechatCode() {
  return 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx6cfd6f1d50ea07ba&redirect_uri='+ encodeURIComponent(origin) +'&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect';
}


// 根据code获取公众号用户信息
export function requestWechatInfo(code) {
	return request({
		url: `/api/wechatUser/wechat/auth?code=${code}`,
		method: 'get',
	});
}